import { render, staticRenderFns } from "./List-Roles.vue?vue&type=template&id=d402977e&scoped=true"
import script from "./List-Roles.vue?vue&type=script&lang=js"
export * from "./List-Roles.vue?vue&type=script&lang=js"
import style0 from "./List-Roles.vue?vue&type=style&index=0&id=d402977e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d402977e",
  null
  
)

export default component.exports